module.exports = __webpack_public_path__ + "static/media/sunlight.2835c466.png";